import { cx } from '@/utils/cx'
import logo from '../../marke/veeky-logo.png'

/**
 * Das Logo mit Untertitel — für Anmelde- und Zugangsseiten.
 *
 * Das ist das vollständige Logo aus `packages/ui/marke/veeky-logo.png`:
 * Symbol, Schriftzug „VeeKy", Untertitel „Voice Kommunikation made Easy".
 * In der Kopfleiste steht dagegen die `Wortmarke` ohne Untertitel — der
 * Untertitel gehört auf die Seite, auf der jemand ankommt, nicht in jede
 * Ansicht.
 */
export function Logo({ className }: { className?: string }) {
  return (
    <img
      src={logo}
      alt="VeeKy — Voice Kommunikation made Easy"
      className={cx('h-auto w-72 max-w-full select-none', className)}
      draggable={false}
    />
  )
}
